import React, { useState } from "react";
import ReactECharts from "echarts-for-react";

import "./AnalysisCard.scss";
import { AnalysisCard } from "./AnalysisCard";
import { Api } from "../../common/Api";
import { fmtDate } from "../../common/Utils";

export const UserRating = () => {
  const [options, setOptions] = useState({
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: [],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: [],
        type: "line",
      },
    ],
  });
  const onStart = ({ interval, period }) => {
    Api.dashboard
      .analysisUserRating({
        interval,
        period: period.map((x) => x.toISOString()),
      })
      .then((res) => {
        console.log(res.data.analysisAppRating);
        const analysisUserRating = res.data.analysisUserRating;
        const xData = analysisUserRating.series[0].data.map((x) => fmtDate(x.key));
        const series = analysisUserRating.series.map((s) => {
          return {
            data: s.data.map((x) => x.value),
            type: "line",
          };
        });
        let options2 = JSON.parse(JSON.stringify(options));
        options2.xAxis.data = xData;
        options2.series = series;
        setOptions({ ...options2 });
      });
  };

  return (
    <AnalysisCard title="User Rating" onStart={onStart}>
      <ReactECharts style={{ height: 400 }} option={options} />
    </AnalysisCard>
  );
};
